import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { RequestsContext } from "../../context/requests";
import { SalleContext } from '../../context/salle'

import { useNavigate } from "react-router-dom";

const Image = styled.img`
  width: 28px;
  height: 26px;
  object-fit: contain;

  @media screen and (max-width: 720px) {
    width: 21px;
    height: 21px;
    margin-left: 0.8rem;
  }
`;

const CheckBox = styled.input`
  border: 1px solid black;
  width: 19px;
  height: 19px;
`;

const CheckBoxTable = styled.input`
  position: relative;
  border: 1px solid black;
  width: 19px;
  height: 19px;
  top: 0.2rem;
  margin-right: 0.5rem;
`;

const Clean = styled.div`
  height:5rem;
`
const ButtonStatus = styled.button`
    font-family: "Poppins";
    font-weight: 600;
    width: 106px;
    height: 28px;
    border: none;
    font-size: 11px;
    border-radius: 60px;

    @media screen and (max-width:820px){
        width: 100%;
        font-size: 9px;
        border-radius:50px;
        
    }


`

const TableListSallesOrder = ({ structure }) => {
  const navigate = useNavigate()
  const [selectedItems, setSelectedItems] = useState([]);
  const { requests, getAll, handleSelectItems, haveRequests } = useContext(RequestsContext);
  const { getById, setSalleStatus } = useContext(SalleContext)

  const toggleSelectAll = (e) => {
    const isChecked = e.target.checked;
    const allIds = isChecked ? requests.map((r) => r.id) : [];

    setSelectedItems(allIds);

    // Atualiza todos os checkboxes de forma síncrona
    requests.forEach((item) => {
      handleSelectItems(item.id, { target: { checked: isChecked } }, item.type_delivery, item.price, item.quantity, item.coust_delivery);
    });
  };
  const toggleSelectItem = (id, e, type_delivery, price, quantity, coust_delivery) => {
    const isChecked = e.target.checked;
    setSelectedItems((prev) =>
      isChecked ? [...prev, id] : prev.filter((item) => item !== id)
    );
    handleSelectItems(id, e, type_delivery, price, quantity, coust_delivery);
  };
  const redirectToSallePage = (id, status) => {
    getById(id)
    setSalleStatus(status)
    navigate("/dashboard/salle")
  }

  useEffect(() => {
    getAll(1);
  }, []);
  useEffect(() => {
    if (selectedItems.length === requests.length) {
      requests.forEach((item) => {
        handleSelectItems(item.id, { target: { checked: true } }, item.type_delivery);
      });
    }
  }, [selectedItems]);

  return (
    <div className="container_startpn_table_categorys">
      <table>
        <thead>
          <tr>
            {structure?.map((item, index) => (
              <td key={index}>
                {item.name === "Selecionar" ? (
                  <CheckBoxTable
                    type="checkbox"
                    onChange={toggleSelectAll}
                    checked={selectedItems.length === requests.length && requests.length > 0}
                  />
                ) : null}
                {item.name == "Selecionar" ? <></> : item.name}
              </td>
            ))}
          </tr>
        </thead>

        {haveRequests

          ?
          <tbody>

            {requests.length === 0 ? (
              <tr>
                {Array.from({ length: 7 }).map((_, index) => (
                  <td key={index}>
                    <Skeleton width="100%" />
                  </td>
                ))}
              </tr>
            ) : (
              requests.map((item) => {
                const formattedDate = new Date(item.createdAt).toLocaleDateString("pt-BR");
                const formattedPrice = (item.price * item.quantity) + Number(item.coust_delivery)


                return (
                  <tr key={item.id}>
                    <td >
                      <CheckBox
                        type="checkbox"
                        checked={selectedItems.includes(item.id)}
                        onChange={(e) => toggleSelectItem(item.id, e, item.type_delivery, item.price, item.quantity, item.coust_delivery)}
                      />
                    </td>
                    <td onClick={() => redirectToSallePage(item.id, item.status)}>#{item.id}</td>
                    <td onClick={() => redirectToSallePage(item.id, item.status)}>#{item.sku}</td>
                    <td onClick={() => redirectToSallePage(item.id, item.status)}>{formattedDate}</td>
                    <td onClick={() => redirectToSallePage(item.id, item.status)}>{item.userName}</td>
                    <td onClick={() => redirectToSallePage(item.id, item.status)}>R$ {formattedPrice.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}</td>
                    <td>
                      {item.status == null || item.status == 1

                        ?
                        <ButtonStatus style={{ background: "#FFF7AA", color: "#C6B200" }}>Em Aberto</ButtonStatus>
                        :

                        item.status == 2

                          ?
                          <ButtonStatus style={{ background: "#E0FFF0", color: "#00B386" }}>Separando</ButtonStatus>

                          :

                          item.status == 3

                            ?
                            <ButtonStatus style={{ background: "#D7DDFF", color: "#4F31F7" }}>Produzindo</ButtonStatus>
                            :
                            item.status == 4

                              ?

                              <ButtonStatus style={{ background: "#FFF898", color: "#E3A010" }}>Embalando</ButtonStatus>
                              :
                              item.status == 5

                                ?

                                <ButtonStatus style={{ background: "#A3F9D0", color: "#0A906E" }}>Enviado</ButtonStatus>

                                :

                                item.status == 6

                                  ?
                                  <ButtonStatus style={{ background: "#f73535", color: "#ffffff" }}>Cancelado</ButtonStatus>
                                  :

                                  item.status == 7
                                    ?
                                    <ButtonStatus style={{ background: "#3ae693", color: "#ffffff" }}>Faturado</ButtonStatus>

                                    :
                                    item.status == 8

                                      ?
                                      <ButtonStatus style={{ background: "#4b3ae6", color: "#ffffff" }}>Preparando</ButtonStatus>

                                      :

                                      item.status == 9
                                        ?
                                        <ButtonStatus style={{ background: "#28e938", color: "#ffffff" }}>Entregue</ButtonStatus>

                                        :



                                        <></>
                      }
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
          :
          <tbody></tbody>
        }


      </table>
      <Clean />
    </div>
  );
};

export default TableListSallesOrder;
